import { fetch, Method, getPaging } from 'core/api/fetch';

const CurrencyRoutes = {
    getList: (options) => `/api/v1.1.1/currency/rates?${options?.code?.length > 0 ? `code=${options.code}&` : ''}${options?.overrideFilter ? `isOverride=${options.overrideFilter}&` : ''}${options?.overrideFilter ? getPaging(options) : ''}`,
};

export const CurrencyService = {
    getList: async (options) => {
        try {
            if (options?.overrideFilter === 'all') {
                options.overrideFilter = null;
            }

            const { data } = await fetch(CurrencyRoutes.getList(options), {
                method: Method.GET,
                authenticated: true,
            });
            return !data
                ? { currencies: [], total: 0 }
                : {
                      total: data.total,
                      currencies: data.rates,
                  };
        } catch (err) {
            throw new Error(err);
        }
    },
};
